import React, { useState } from "react";
import SplashScreen from "./SplashScreen";
import CalendarView from "./CalendarView";
import AddReservation from "./pages/AddReservation";
import EditReservation from "./pages/EditReservation";
import EventDetail from "./pages/EventDetail";
import Concepts from "./pages/Concepts";
import Home from "./pages/Home";
import Items from "./pages/Items";
import Reservations from "./pages/Reservations";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { Routes, Route } from "react-router-dom";
import { AlertProvider } from "./context/AlertContext";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  if (showSplash) {
    return <SplashScreen onFinish={() => setShowSplash(false)} />;
  }

  return (
    <AlertProvider>
              <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/takvim" element={<ProtectedRoute><CalendarView /></ProtectedRoute>} />
          <Route path="/rezervasyon-olustur" element={<ProtectedRoute><AddReservation /></ProtectedRoute>} />
          <Route path="/rezervasyon-duzenle/:id" element={<ProtectedRoute><EditReservation /></ProtectedRoute>} />
          <Route path="/etkinlik/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
          <Route path="/event/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
          <Route path="/konsept-gorselleri" element={<ProtectedRoute><Concepts /></ProtectedRoute>} />
          <Route path="/malzeme-gorselleri" element={<ProtectedRoute><Items /></ProtectedRoute>} />
          <Route path="/rezervasyonlar" element={<ProtectedRoute><Reservations /></ProtectedRoute>} />
        </Routes>
          </AlertProvider>
  );
}

export default App;
